"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Card, CardContent } from "@mui/material";
import model3 from "../../../Static/Models/model3.svg";

const categories = [
  { id: 1, title: "Gears / Gear Box" },
  { id: 2, title: "Boilers" },
  { id: 3, title: "Softy Machinery" },
  { id: 4, title: "Road Construction Machinery" },
  { id: 5, title: "Pharmaceuticals" },
  { id: 6, title: "Steel & Metal" },
  { id: 7, title: "Software IT services" },
  { id: 8, title: "Construction Resi & Comm" },
  { id: 9, title: "Security Services" },
  { id: 10, title: "Chemical Traders" },
  { id: 11, title: "Computer Peripherals Traders" },
  { id: 12, title: "Textiles" },
];

export default function CategorySlider() {
  return (
    <div className="flex justify-center w-full">
      <div className="w-full max-w-6xl px-4 py-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* Left Section: Image */}
          <div className="flex items-center justify-center">
            <img
              src={model3}
              alt="Category Image"
              className="w-full max-w-sm"
            />
          </div>

          {/* Right Section: Title and Slider */}
          <div>
            {/* Header Section */}
            <h2 className="text-3xl font-bold text-center lg:text-left mb-6 text-[#151C62]">
              Clientele Categories
            </h2>

            {/* Swiper Slider */}
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={2}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              loop={true}
              breakpoints={{
                480: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
            >
              {categories.map((category) => (
                <SwiperSlide key={category.id}>
                  <div className="py-4">
                    <Card
                      className="flex items-center justify-center shadow-lg"
                      style={{
                        height: "220px",
                        borderRadius: "16px",
                        background: "linear-gradient(135deg, #E0EFFF, #151C62)",
                        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                        color: "#fff",
                      }}
                    >
                      <CardContent>
                        <h3 className="text-sm sm:text-xl font-bold text-center p-2 break-words">
                          {category.title}
                        </h3>
                      </CardContent>
                    </Card>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}
